// Include flickity
import 'flickity/dist/flickity.pkgd.min.js';
import 'flickity-sync/flickity-sync.js';

// Set global arrowShape
const arrowShape = 'M95.5527909,45.7663635 L15.2361941,45.7663635 L44.9316918,16.6220357 C46.6838922,14.8994666 46.7105755,12.0858382 44.9909879,10.3306559 C43.2654708,8.57843848 40.4518698,8.5547198 38.6996694,10.2713592 L1.33125355,46.9463678 C0.483319007,47.7794864 0.00302042156,48.9150182 0,50.1009522 C-0.00587399669,51.2868862 0.462565364,52.4283477 1.30160549,53.267396 L38.7322823,90.6984374 C39.6009705,91.5671341 40.739456,92 41.8779415,92 C43.0134623,92 44.1519478,91.5671341 45.020636,90.6984374 C46.7580124,88.9610442 46.7580124,86.1444509 45.020636,84.4100225 L15.2717718,54.6608684 L95.5527909,54.6608684 C98.0076503,54.6608684 100,52.6684993 100,50.2136159 C100,47.7557678 98.0076503,45.7663635 95.5527909,45.7663635';

// Init sliders
$(window).on('ready load', function() {
  // @TODO: Wrap slider in each loop, if the slider is used inside of a gutenberg block

  // News slider
  $('.news-slider').each(function(i, e) {
    function carouselStatus(slider, status) {
      var slideNumber = slider.selectedIndex + 1;
      var slideTotal = slider.slides.length;
      status.text(slideNumber + '/' + slideTotal);
    }

    // Add reset height class when resizing, and remove when resizing is done
    let resizeTimer;
    $(window).on('resize', function () {
      $(e).find('.news-slider__item').addClass('reset-height');

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        $(e).find('.news-slider__item').removeClass('reset-height');
      }, 250);
    });

    if($(e).length && (
      ($(window).width() < 768 && $(e).find('.news-slider__item').length > 1) ||
      ($(window).width() > 767 && $(window).width() < 1025 && $(e).find('.news-slider__item').length > 2) ||
      ($(window).width() > 1024 && $(e).find('.news-slider__item').length > 3)
    )) {
      var $carousel = $(e).flickity({
        arrowShape: arrowShape,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
      });
      $(e).flickity('resize');

      var flkty = $carousel.data('flickity');
      var statusWrap = $('.carousel-status');
      carouselStatus(flkty, statusWrap);

      $carousel.on( 'change.flickity', function() {
        carouselStatus(flkty, statusWrap);
      });
    } else if($(e).hasClass('flickity-enabled')) {
      $(e).flickity('destroy');
    }
  });

  if ($('.js-usp-slider').length && $('.js-usp-slider-single').length > 1) {
    var uspslider = $('.js-usp-slider').flickity({
      contain: true,
      wrapAround: true,
      cellAlign: 'left',
      watchCSS: true,
      autoPlay: 3000,
      prevNextButtons: false,
      pageDots: false,
      initialIndex: Math.floor(Math.random() * $('.js-usp-slider-single').length),
    });
    uspslider.flickity('resize');
    $(window).on('ready load', function () {
      uspslider.flickity('resize');
    });
  }

  // Image slider
  $('.js-img-slider').each(function(i, e) {
    if($(e).length && $(e).find('.js-img-slider__item').length > 1) {
      $(e).flickity({
        wrapAround: true,
        arrowShape: arrowShape,
        cellSelector: '.js-img-slider__item',
      });

      $(e).flickity('resize');
    }
  });

  // Image slider
  $('.testimonial__text-slider').each(function(i, e) {
    if($(e).length && $(e).find('.testimonial__text-item').length > 1) {
      $(e).flickity({
        sync: '.testimonial__info-slider',
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
      });

      $('.testimonial__info-slider').flickity({
        contain: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
      $('.testimonial__info-slider').flickity('resize');
    }
  });

  // Team slider
  $('.team-slider').each(function(i, e) {
    if($(e).length && $(e).find('.card-team').length > 1) {
      $(e).flickity({
        watchCSS: true,
        wrapAround: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/global/flickity.js